import { render, staticRenderFns } from "./AutoTraderDealCard.vue?vue&type=template&id=3e6aa207&scoped=true"
import script from "./AutoTraderDealCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./AutoTraderDealCard.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AutoTraderDealCard.vue?vue&type=style&index=0&id=3e6aa207&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e6aa207",
  null
  
)

export default component.exports